/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import config from 'js/app/config';
import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Button, Typography, Typography2 } from '@coursera/cds-core';

import TrackedButton from 'bundles/page/components/TrackedButton';
import EoiQuestion from 'bundles/xddp/components/landing/EoiQuestion';
import EoiTerminal from 'bundles/xddp/components/landing/EoiTerminal';
import withEoiControls from 'bundles/xddp/components/landing/withEoiControls';
import LoadingIcon from 'bundles/xddp/components/shared/LoadingIcon';
import type { EoiFormProps } from 'bundles/xddp/types';

import _t from 'i18n!nls/xddp';

import 'css!bundles/xddp/components/__styles__/landing/EoiForm';

const styles = {
  spinnerContainer: css`
    display: flex;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  `,
  buttonLabelContainer: (visibility: string) => css`
    visibility: ${visibility};
  `,
};

class EoiForm extends React.Component<EoiFormProps> {
  renderQuestions = () => {
    const { questions, validationErrors, handleInputChangeFunc, setRegion } = this.props;

    return questions.map((questionInfo) => (
      <EoiQuestion
        key={questionInfo.id}
        questionInfo={questionInfo}
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        validationError={validationErrors[questionInfo.id]}
        handleInputChangeFunc={handleInputChangeFunc}
        setRegion={setRegion}
      />
    ));
  };

  render() {
    const { shortName, partnerName, onClickNext, questions, isSubmitting = false } = this.props;

    const isSurveyOneClick = questions.length === 0;

    return (
      <div className="rc-EoiFormEmbedded">
        <div>
          {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
          <Typography variant="h2" className="eoi-header">
            <FormattedMessage message={_t('Interested in the {shortName}?')} shortName={shortName} />
          </Typography>
          <Typography2 component="p" variant="bodyPrimary">
            {isSurveyOneClick
              ? _t("Please click request info and we'll contact you with information about the degree.")
              : _t("Please answer a few questions and we'll contact you with information about the degree.")}
          </Typography2>
        </div>
        {!isSurveyOneClick && this.renderQuestions()}
        <Typography2 component="p" className="tosNotice" variant="bodySecondary">
          <FormattedMessage
            message={_t(
              'Secure form. By submitting, I agree that Coursera will share the above information with {partnerName}. I also specifically consent to Coursera, {partnerName}, or an authorized marketing affiliate to contact me to follow up on my submission and answer any questions I may have. Furthermore, while interacting with the Coursera website, I agree to abide by {tosLink}.'
            )}
            partnerName={partnerName}
            tosLink={<a href={`${config.url.base}about/terms`}>Coursera’s Terms of Use</a>}
          />
        </Typography2>
        <Button
          variant="primary"
          trackingName="eoi_request_info"
          className="rc-EoiAction"
          onClick={onClickNext}
          component={TrackedButton}
          withVisibilityTracking={true}
          requireFullyVisible={true}
        >
          <span css={styles.buttonLabelContainer(isSubmitting ? 'hidden' : 'visible')}>{_t('Request Info')}</span>

          {isSubmitting ? (
            <span css={styles.spinnerContainer}>
              <LoadingIcon size="large" color="invert" />
            </span>
          ) : null}
        </Button>
      </div>
    );
  }
}

export default withEoiControls(EoiForm, EoiTerminal);
